export default __webpack_public_path__ + "static/media/lamp.54d2f20a.PNG";